<template>
  <div class="home">
    <v-e24-nav-bar/>
	<headerImageFull/>
	<plecaVerde/>
	<plecaBlanca/>
    <v-e24-footer :build="build"/>
  </div>
</template>

<script>
import headerImageFull from '@/components/home/HeaderImageFull'
import plecaVerde from '@/components/home/PlecaVerde'
import plecaBlanca from '@/components/home/PlecaBlanca'
import readBuild from '../util/readBuild'

export default {
	name: 'home',
	data () {
		return {
			build: ''
		}
	},
	components: {
		headerImageFull,
		plecaVerde,
		plecaBlanca
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
		this.$nextTick(() => {
			document.title = 'California Title 24 Report Service: Energy Compliance and Calculations'
		})
	},
	created: function () {
		// this.detectBrowser()
	}
}

</script>



// WEBPACK FOOTER //
// src/views/Home.vue